import { useAuthStore } from '../stores/auth-store';

/**
 * Returns true if the currently authenticated user has the given permission code.
 *
 * Permission codes correspond to the constants in EssencePermissions (Java backend).
 * Example: useHasPermission('00901') → true when user has USER_MANAGEMENT.
 */
export const useHasPermission = (permissionCode: string): boolean => {
    const user = useAuthStore((state) => state.user);
    if (!user) return false;
    // permissions is returned by the backend but not yet in the generated type
    const permissions = (user as any).permissions as string[] | undefined;
    return Array.isArray(permissions) && permissions.includes(permissionCode);
};
